export default "__VITE_ASSET__a9a97999__"